export default "assets/images/texture_quote-c65f65df.png";